export default __webpack_public_path__ + "static/media/example-johnlewis-IMG.770fbb26.jpg";